import { DataEntry } from '../../../lib/types';
import { joinWaitlist } from '../../../modules/course/api';
import { Roster } from '../../../modules/course/types';

export const joinWaitlistUseCase = async (courseId: number): Promise<DataEntry<Roster>> => {
  return joinWaitlist(courseId);
};
